import { dateUtils, urlUtils } from '@festina-life/core'
import { Button } from '@festina-life/ui/actions'
import { DatePicker } from '@festina-life/ui/forms'
import { useTranslate } from '@festina-life/ui/hooks'
import { paperStyles, zIndexStyles } from '@festina-life/ui/libs'
import {
  Icon,
  Popover,
  PopoverButton,
  PopoverPanel,
} from '@festina-life/ui/structure'
import cx from 'classnames'
import { useState } from 'react'

import { useLayoutContext } from '../../context/layoutContext'
import { useParameterDefinitionId } from '../../hooks/useParameterDefinitionId'
import { useLazyFetchParameterValuesCsv } from '../../uiModels/api/parameters/useLazyFetchParameterValuesCsv'

export const ParameterValuesExportButton = () => {
  const translate = useTranslate()
  const [exportDate, setExportDate] = useState<string>()
  const { mutateAsync, isPending } = useLazyFetchParameterValuesCsv()
  const parameterDefinitionId = useParameterDefinitionId()
  const {
    preferences: {
      parameters: { isFlattened },
    },
  } = useLayoutContext()
  const handleClick = async () => {
    const result = await mutateAsync(dateUtils.dateAsServerStr(exportDate))

    if (result) {
      const csvBlob = new Blob([result], { type: 'text/plain' })
      urlUtils.downloadAsFile(
        csvBlob,
        `${parameterDefinitionId}-values${isFlattened ? '-flattened' : ''}.csv`,
      )
    }
  }

  return (
    <Popover className="relative">
      <PopoverButton className="flex items-center gap-x-2">
        <Icon name="ChevronDown" />
        {isFlattened
          ? translate('parameterViewer.topBar.exportValuesPopover.flattened')
          : translate(
              'parameterViewer.topBar.exportValuesPopover.nonFlattened',
            )}
      </PopoverButton>
      <PopoverPanel
        isShowingBackdrop
        className={cx(
          'fixed rounded-lg p-2 shadow-lg max-w-2xs w-2xs flex flex-col gap-2',
          paperStyles({ isFaded: true, borders: ['all'] }),
          zIndexStyles('popovers'),
        )}
        anchor="bottom start"
      >
        <DatePicker
          value={exportDate}
          onChange={setExportDate}
          wrapperProps={{
            label: translate(
              'parameterViewer.topBar.exportValuesButton.atDate.label',
            ),
            description: translate(
              'parameterViewer.topBar.exportValuesButton.atDate.description',
            ),
          }}
        />
        <Button
          variant="primary"
          onClick={handleClick}
          disabled={isPending}
          isLoading={isPending}
        >
          {translate('parameterViewer.topBar.exportValuesButton')}
        </Button>
      </PopoverPanel>
    </Popover>
  )
}
